import React, { Suspense, lazy } from 'react';

//import { AutoPauseVideo } from '../Generic/AutoPauseVideo';
import PageSection from '../PageSections/PageSection';
import ContentfulImage from './ContentfulImage';
import * as styles from './FloatingCallout.module.scss';
import { ArrowLink } from './Links';
import RichTextConverter from './RichText/RichTextConverter';

const AutoPauseVideo = lazy(() =>
  import('../Generic/AutoPauseVideo').then((module) => ({ default: module.AutoPauseVideo }))
);

export default function FloatingCallout({ section, wide, shadow, bgOverlap = false, rounded = true }) {
  const imageLeft = section.imageLocation === true;
  const imageBleed = section.imageStyle === 'Bleed';

  let mediaSection = null;
  if (section.mainImage) {
    mediaSection = imageBleed ? (
      <div className={styles.image} data-analytics-component={'callout-image'}>
        <ContentfulImage
          imageFragment={section.mainImage}
          height={section.mainImage.height}
          width={section.mainImage.width}
        />
      </div>
    ) : (
      <ContentfulImage
        data-analytics-component={'callout-image'}
        className={styles.image}
        imageFragment={section.mainImage}
        height={section.mainImage.height}
        width={section.mainImage.width}
      />
    );
  }
  if (section.wistiaUrl) {
    mediaSection = (
      <Suspense fallback={<div>loading...</div>}>
        <AutoPauseVideo controls={true} src={section.wistiaUrl} classes={[styles.videoPlayer]} />
      </Suspense>
    );
  }
  return (
    <PageSection
      slim
      className={[styles.container, styles[section.backgroundColor], bgOverlap ? styles.backgroundOverlap : ''].join(
        ' '
      )}
      wide
      data-analytics-section={'floating-callout'}
    >
      <div
        className={[
          styles.floatingCallout,
          wide ? styles.wide : '',
          shadow ? styles.shadow : '',
          rounded ? styles.rounded : '',
        ].join(' ')}
        style={{ '--backgroundImage': `url('${section.backgroundImage?.file?.url}')` }}
      >
        <div
          className={[styles.wrapper, imageBleed ? styles.imageBleed : '', imageLeft ? styles.imageLeft : ''].join(' ')}
        >
          <div className={styles.copy} data-analytics-component={'callout-copy'} data-analytics-id={section.title}>
            {section.subtitle && <div className={styles.subtitle}>{section.subtitle}</div>}
            <h2>{section.title}</h2>
            <RichTextConverter copy={section.copy} />
            {section.ctaUrl && (
              <ArrowLink inheritColor={true} hoverAnimation={true} url={section.ctaUrl} label={section.ctaLabel} />
            )}
          </div>
          {mediaSection}
        </div>
      </div>
    </PageSection>
  );
}
